import { LOGO_THEME } from "../../../../../constants/logo";
import Logo from "../../../../UI/Logo/Logo";
// import facebookIcon from "../../../../../assets/icons/facebook.svg";
// import whatsappIcon from "../../../../../assets/icons/whatsapp.svg";
// import googleIcon from "../../../../../assets/icons/google.svg";
import classes from "./Social.module.css";

const Social = () => {
  return (
    <div className={classes["social"]}>
      <Logo theme={LOGO_THEME.WHITE} className={classes["social__logo"]} />
      <address className={classes["social__address"]}>المعادي, القاهرة</address>
      {/* <div className={classes["social__line"]} /> */}
      {/* <ul className={classes["social__links"]}>
        <li>
          <a href="/" target="_blank">
            <img src={whatsappIcon} alt="whatsapp" />
          </a>
        </li>
        <li>
          <a href="/" target="_blank">
            <img src={facebookIcon} alt="facebook" />
          </a>
        </li>
        <li>
          <a href="/" target="_blank">
            <img src={googleIcon} alt="google" />
          </a>
        </li>
      </ul> */}
    </div>
  );
};

export default Social;
